import { render, staticRenderFns } from "./AccountTable.vue?vue&type=template&id=27c24928&scoped=true&"
import script from "./AccountTable.vue?vue&type=script&lang=js&"
export * from "./AccountTable.vue?vue&type=script&lang=js&"
import style0 from "./AccountTable.vue?vue&type=style&index=0&id=27c24928&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c24928",
  null
  
)

export default component.exports